import { useState } from 'react';
import {UseGetCategoriesResult} from "../types/api";



const useGetCategories = (): UseGetCategoriesResult => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<any>(null);

    const getCategories = async (offset = 0, limit = 100) => {
        setIsLoading(true);
        setError(null);

        try {
            const apiUrl = process.env.REACT_APP_API_BASE || '/api';

            const response = await fetch(`${apiUrl}/category/?offset=${offset}&limit=${limit}`, {
                method: 'GET',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }

            const result = await response.json();
            setData(result);
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { getCategories, isLoading, error, data };
};

export default useGetCategories;